export enum BusinessSnapshotTrackingEvents {
  BusinessSnapshotCtaViewed = 'Business Snapshot CTA Viewed',
  BusinessSnapshotCtaClicked = 'Business Snapshot CTA Clicked',
  BusinessSnapshotViewed = 'Business Snapshot Viewed',
  BusinessSnapshotClicked = 'Business Snapshot Clicked',
}
